<template>
  <div>
    <!-- Mobile overlay -->
    <div 
      v-if="isOpen && isMobile" 
      class="sidebar-overlay" 
      @click="$emit('close')"
    ></div>
    
    <nav class="sidebar" :class="{ 'sidebar-mobile': isMobile, 'sidebar-open': isOpen }">
      <div class="sidebar-header">
        <div class="logo-placeholder">
          <img src="/logo.png" alt="Лого" class="logo" />
        </div>
        <h2>НовЖивот Админ</h2>
        <!-- Mobile close button -->
        <button 
          v-if="isMobile" 
          @click="$emit('close')" 
          class="mobile-close-btn"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
      
      <ul class="sidebar-menu">
        <li>
          <router-link 
            to="/dashboard" 
            class="menu-item" 
            :class="{ active: $route.name === 'Dashboard' }"
            @click="handleMenuClick"
          >
            <i class="fas fa-tachometer-alt"></i>
            Табло
          </router-link>
        </li>
        <li>
          <router-link 
            to="/users" 
            class="menu-item" 
            :class="{ active: $route.name === 'Users' }"
            @click="handleMenuClick"
          >
            <i class="fas fa-users"></i>
            Потребители
          </router-link>
        </li>
        <li>
          <router-link 
            to="/churches" 
            class="menu-item" 
            :class="{ active: $route.name === 'Churches' }"
            @click="handleMenuClick"
          >
            <i class="fas fa-church"></i>
            Църкви
          </router-link>
        </li>
        <li>
          <router-link 
            to="/categories" 
            class="menu-item" 
            :class="{ active: $route.name === 'Categories' }"
            @click="handleMenuClick"
          >
            <i class="fas fa-tags"></i>
            Категории
          </router-link>
        </li>
        <li>
          <router-link 
            to="/chat" 
            class="menu-item" 
            :class="{ active: $route.name === 'Chat' }"
            @click="handleMenuClick"
          >
            <i class="fas fa-comments"></i>
            Чат
          </router-link>
        </li>
      </ul>
      
      <div class="sidebar-footer">
        <button @click="logout" class="btn btn-secondary logout-btn">
          <i class="fas fa-sign-out-alt"></i>
          Изход
        </button>
      </div>
    </nav>
  </div>
</template>

<script>
import { signOut } from 'firebase/auth'
import { auth } from '../firebase'

export default {
  name: 'SidebarComponent',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  methods: {
    async logout() {
      try {
        await signOut(auth)
        this.$router.push('/login')
      } catch (error) {
        console.error('Logout error:', error)
      }
    },
    handleMenuClick() {
      // Close sidebar on mobile when menu item is clicked
      if (this.isMobile) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 260px;
  background: #1D687B;
  color: white;
  display: flex;
  flex-direction: column;
  position: fixed;
  height: 100vh;
  top: 0;
  left: 0;
  overflow-y: auto;
  z-index: 1000;
  transition: transform 0.3s ease;
}

.sidebar-mobile {
  transform: translateX(-100%);
  height: 100vh;
  max-height: 100vh;
  top: 0;
}

.sidebar-mobile .sidebar-menu {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 10px;
}

.sidebar-mobile .sidebar-footer {
  flex-shrink: 0;
  padding: 15px 20px;
  padding-bottom: calc(15px + env(safe-area-inset-bottom, 10px));
}

.sidebar-mobile.sidebar-open {
  transform: translateX(0);
}

.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.sidebar-header {
  padding: 24px 20px;
  border-bottom: 1px solid rgba(121, 218, 242, 0.2);
  text-align: center;
  position: relative;
}

.mobile-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.mobile-close-btn:hover {
  background-color: rgba(121, 218, 242, 0.2);
}

.logo-placeholder {
  margin-bottom: 16px;
}

.logo {
  width: 120px;
  height: 120px;
  object-fit: contain;
  border-radius: 8px;
  padding: 8px;
}

.sidebar-mobile .logo {
  width: 80px;
  height: 80px;
}

.sidebar-header h2 {
  font-size: 20px;
  font-weight: 700;
  color: #F8F8F8;
}

.sidebar-menu {
  flex: 1;
  list-style: none;
  padding: 20px 0;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  color: #F8F8F8;
  text-decoration: none;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;
}

.menu-item:hover {
  background-color: rgba(121, 218, 242, 0.2);
  color: #79daf2;
}

.menu-item.active {
  background-color: #ffffff;
  color: #333333;
  border-left-color: #1D687B;
}

.menu-item i {
  width: 16px;
  text-align: center;
}

.sidebar-footer {
  padding: 20px;
  border-top: 1px solid rgba(121, 218, 242, 0.2);
  margin-top: auto; /* Push footer to bottom */
}

.logout-btn {
  width: 100%;
  justify-content: center;
  background-color: #ffffff;
  color: #333333;
}
</style>
